import { CampaignType } from '@/types/campaign-type';
import { AnalyticCampaignType } from '@/types/analytic-campaign-type.ts';

export function useCampaignType() {
  function isCampaignTypeValid(type: string): type is CampaignType {
    return Object.values(CampaignType)
      .map((v) => v.toLowerCase())
      .includes(type.toLowerCase() as CampaignType);
  }

  function isTomraCampaign(type?: string): type is CampaignType.TOMRA {
    return type?.toLowerCase() === CampaignType.TOMRA.toLowerCase();
  }

  function isTokenCampaign(type?: string): type is CampaignType.TOKEN {
    return type?.toLowerCase() === CampaignType.TOKEN.toLowerCase();
  }

  function isCashbackTokenCampaign(
    type?: string
  ): type is CampaignType.CASHBACK_BRANDS {
    return type?.toLowerCase() === CampaignType.CASHBACK_BRANDS.toLowerCase();
  }

  function getTotalSteps(type?: string) {
    if (isTomraCampaign(type)) {
      return 5;
    }

    return 3;
  }

  function toAnalyticCampaignType(campaignType?: string) {
    switch (campaignType) {
      case CampaignType.TOMRA:
        return AnalyticCampaignType.TOMRA;
      case CampaignType.TOKEN:
        return AnalyticCampaignType.TOKEN;
      case CampaignType.CASHBACK_BRANDS:
        return AnalyticCampaignType.CASHBACK_BRANDS;
      default:
        return undefined;
    }
  }

  return {
    isCampaignTypeValid,
    isTomraCampaign,
    isTokenCampaign,
    isCashbackTokenCampaign,
    getTotalSteps,
    toAnalyticCampaignType,
  };
}
